import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { MongoIdInput } from '../../../../types/schema/utils.types';
import { Proposal } from '../../../../types/schema/proposal.types';

interface GetProposalDetailsByIdHook {
  data: Proposal | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getProposalDetailsById: Proposal;
    }>
  >;
}

interface GetProposalDetailsByIdMutationData {
  getProposalDetailsById: Proposal;
}

interface GetProposalDetailsByIdInputType {
  input: MongoIdInput;
}

export function useGetProposalDetailsById(
  query: DocumentNode,
  input: MongoIdInput
): GetProposalDetailsByIdHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetProposalDetailsByIdMutationData,
    GetProposalDetailsByIdInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getProposalDetailsById,
    loading,
    error,
    refetch,
  };
}
